import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, UserPlus } from "lucide-react";
import { api, formatApiError } from "../api";
import { useAuth } from "../AuthContext";

export function UsersAdmin() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", role: "admin", password: "" });

  const load = () => api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/users", form);
      toast.success("Usuario creado");
      setForm({ name: "", email: "", role: "admin", password: "" });
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const remove = async (u) => {
    if (!window.confirm(`¿Eliminar a ${u.email}?`)) return;
    try {
      await api.delete(`/admin/users/${u.id}`);
      toast.success("Usuario eliminado");
      setUsers((prev) => prev.filter((x) => x.id !== u.id));
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const input = "w-full border border-[#B2967D]/50 px-3 py-2.5 text-sm bg-white focus:outline-none focus:border-[#7D5A44] font-light";

  return (
    <div data-testid="admin-users">
      <h1 className="text-3xl font-bold text-black">Usuarios</h1>
      <p className="mt-2 text-sm font-light text-black/50">Crea y administra las cuentas del panel.</p>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Create form */}
        <form onSubmit={create} className="bg-white border border-[#B2967D]/25 p-6 space-y-4 h-fit" data-testid="user-create-form">
          <h3 className="text-sm font-bold uppercase tracking-wide text-[#B2967D] flex items-center gap-2">
            <UserPlus size={16} /> Nuevo usuario
          </h3>
          <input className={input} placeholder="Nombre" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="user-name" />
          <input className={input} type="email" placeholder="Correo" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="user-email" />
          <select className={input} value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="user-role">
            <option value="admin">Admin</option>
            <option value="super_admin">Super Admin</option>
          </select>
          <input className={input} type="password" placeholder="Contraseña temporal" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="user-password" />
          <button type="submit" data-testid="user-create-btn" className="w-full bg-[#7D5A44] text-white px-5 py-3 text-xs font-bold uppercase tracking-wide hover:bg-black transition-colors">
            Crear usuario
          </button>
        </form>

        {/* Users list */}
        <div className="lg:col-span-2 bg-white border border-[#B2967D]/25 overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-[#F5F1EA] text-left text-[11px] uppercase tracking-wide text-[#B2967D]">
                <th className="px-4 py-3 font-bold">Nombre</th>
                <th className="px-4 py-3 font-bold">Correo</th>
                <th className="px-4 py-3 font-bold">Rol</th>
                <th className="px-4 py-3 font-bold text-right">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u, i) => (
                <tr key={u.id} className="border-t border-[#B2967D]/20" data-testid={`user-row-${i}`}>
                  <td className="px-4 py-3 text-sm font-bold text-black">{u.name}</td>
                  <td className="px-4 py-3 text-sm font-light text-black/70">{u.email}</td>
                  <td className="px-4 py-3 text-xs">
                    <span className="px-2 py-1 bg-[#7D5A44] text-white font-bold uppercase tracking-wide">
                      {u.role === "super_admin" ? "Super Admin" : "Admin"}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    {u.id !== user.id && (
                      <button onClick={() => remove(u)} data-testid={`user-delete-${i}`} className="inline-flex items-center border border-[#B2967D]/50 text-black/60 px-3 py-2 text-xs hover:border-red-500 hover:text-red-600 transition-colors">
                        <Trash2 size={14} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
